<template>
  <div>
    <div v-if="hasTitle" :class="brandClasses.title">
      <h2 class="title-2">
        <span v-if="renderedTitleHtml" v-html="renderedTitleHtml" />
        <span v-else>{{ title }}</span>
      </h2>
      <vf-carousel-controls :carousel-ref />
    </div>
    <vf-carousel-elevate
      ref="carouselRef"
      :align="carouselAlign"
      :class-container="brandClasses.carouselContainer"
      :class-controls="brandClasses.carouselControls"
      :loop="carouselLoop"
      :show-arrows="carouselArrowsMapping[carouselArrows]"
      :size-controls="carouselArrowsSize"
    >
      <vf-article-card
        v-for="article in articlesToShow"
        :key="article.id"
        v-bind="article"
        v-style:w="slideWidth"
        :card-content-container="brandClasses.carouselCardContent"
        :class="brandClasses.carouselCard"
        :hide-page-date="content.hidePageDate"
        :image="{
          src: article.picture?.url,
          alt: article.picture.alt,
        }"
        :tags="[article.eyebrow]"
        :to="article.url"
      />
    </vf-carousel-elevate>
  </div>
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { ArticleCarouselContent } from '#types/components/cms/article-carousel'

const { content } = defineProps<{ content: ArticleCarouselContent }>()

const { title, titleHtml } = content

const { $feature, $viewport } = useNuxtApp()
const appConfig = useAppConfig()
const { breakpoints } = appConfig.ds
const {
  brandClasses,
  carouselAlign,
  carouselLoop,
  carouselArrows,
  carouselArrowsSize
} = appConfig.components.cms.articleCarousel
const { articlesToShow } = useArticles({ ...content, kind: 'carousel' })

const renderedTitleHtml = computed(() => $feature.showTitleHtml && hasTextContent(titleHtml) ? titleHtml : '')
const hasTitle = computed(() => !!renderedTitleHtml.value || hasTextContent(title))

const carouselArrowsMapping = {
  on: true,
  mdNoTitle: $viewport.md && !hasTitle.value,
  lgNoTitle: $viewport.lg && !hasTitle.value
}

const carouselRef = ref()

const slideWidth: Record<keyof Responsive, string> = Object.keys(breakpoints).reduce((acc, cur) => ({
  ...acc,
  [cur]: getValueForBreakpoint(cur as keyof Responsive, content.breakpoints)?.slideWidth || 'auto'
}), {} as Record<keyof Responsive, string>)
</script>
